<style src="../assets/style.css">
</style>
<template>
    <div class="about product_list">
        <v-carousel v-if="carousel.carouselitems && carousel.carouselitems.length > 0">
            <v-carousel-item
                class="productListCarousel"
                v-for="(item, index) in carousel.carouselitems"
                :key="index"
                :src="item.media_url"
                reverse-transition="fade"
                transition="fade"
            >
            <!--                <div class="carousel__content" v-html="item.content"></div>-->
            </v-carousel-item>
        </v-carousel>
        <div class="about__container mt-3">
            <div class="row">
                <div class="col-12 col-lg-4">
                    <div class="about__image-container">
                        <img :src="about.page_image" :alt="about.title" class="about__image">
                    </div>
                </div>
                <div class="col-12 col-lg-8">
                    <h1 class="about__title" v-if="about.title"> {{ about.title }} </h1>
                    <div class="about__text" v-html="about.content"></div>
                </div>
            </div>
        </div>

        <app-benefits v-if="benefits.length > 0" :benefits="benefits"></app-benefits>
        <div class="partners" v-if="about.partenerList.length > 0 || testimonials.length > 0">
            <h2 class="partners__title">Parteneri & Testimoniale</h2>
            <app-partners v-if="about.partenerList.length > 0" :partners="about.partenerList"></app-partners>
            <app-testimonials v-if="testimonials.length > 0" :testimonials="testimonials"></app-testimonials>
        </div>
    </div>
</template>


<script>
    import appBenefits from './Shared/Benefits';
    import appPartners from './Shared/Partners';
    import appTestimonials from './Shared/Testimonials';
    import GlobalService from './../services/Global';

    export default {
        data () {
            return {
                about: {
                    partenerList: {
                    
                    }
                },
                carousel: {
                    carouselitems: {
                        
                    }
                },
                benefits: [],
                testimonials: []
            }
        },
        created () {
            this.getAboutUs()
        },
        components: {
            appBenefits,
            appPartners,
            appTestimonials
        },
        methods: {
            getAboutUs () {
                this.$http.get(`/pages/${this.$route.path.replace('/', '')}`)
                .then(response => {
                    this.about = response.data
                    this.testimonials = GlobalService.checkForBenefitsOrTestimonials(this.about.article, 'testimonials')
                    this.benefits = GlobalService.checkForBenefitsOrTestimonials(this.about.article, 'benefits')
                })
                .then(() => {
                    if (this.about.carousel_id) {
                        this.getCarousel(this.about.carousel_id)
                    }
                    GlobalService.initializeCarousel()
                    GlobalService.initializeSecondCarousel()
                    this.about.article = GlobalService.removeBenefitsAndTestimonials(this.about.article)
                })
                .catch(e => {
                    console.log(e)
                    this.$router.push('/404')
                })
            },
            getCarousel (id) {
                this.$http.get(`/carousel/${id}`)
                .then(response => {
                    this.carousel = response.data[0]
                })
                .catch(e => {
                    console.log(e)
                })
            }
        }
    }
</script>
